module.exports = __webpack_public_path__ + "static/produceplan-iphoneicon-fa164b383644efac429c3515c3c0e993.svg";